import { render, staticRenderFns } from "./VoucherBoxEdit.vue?vue&type=template&id=3fbc6318&scoped=true&"
import script from "./VoucherBoxEdit.vue?vue&type=script&lang=js&"
export * from "./VoucherBoxEdit.vue?vue&type=script&lang=js&"
import style0 from "./VoucherBoxEdit.vue?vue&type=style&index=0&id=3fbc6318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc6318",
  null
  
)

export default component.exports